import getScrollbarWidth from 'get-scrollbar-width';

const isNaN = Number.isNaN || (number => number !== number);

const coerceNumber = number => (typeof number !== 'number' || isNaN(number) ? Infinity : number);

// This function calculates both the desired height and width up to and including the given dimensions.
// It calculates the dimensions given the width/height functions for each item that needs to be displayed in the container.
// If either width/height exceeds these dimensions the resulting dimensions will be clamped to the max.
export default ({ items, getItemDimensions, maxWidth, maxHeight }) => {
  let isOverflowingHeight = false;

  // Coerce max*** to numbers, if for some reason they aren't.
  maxWidth = coerceNumber(maxWidth);
  maxHeight = coerceNumber(maxHeight);

  const clampWidth = newWidthCandidate => Math.min(maxWidth, newWidthCandidate);
  const clampHeight = newHeightCandidate => {
    isOverflowingHeight = newHeightCandidate > maxHeight;
    return Math.min(maxHeight, newHeightCandidate);
  };

  const dimensions = items.reduce(
    (dimensions, _, index) => {
      const { width: itemWidth, height: itemHeight } = getItemDimensions(index);

      dimensions.width = clampWidth(Math.max(dimensions.width, itemWidth));
      dimensions.height = clampHeight(dimensions.height + itemHeight);

      return dimensions;
    },
    { width: 0, height: 0 }
  );

  if (isOverflowingHeight) {
    //When just adding the scrollbar width there's still an ellipsis on the content.
    //Probably because the content may be overflowing by less than a pixel (css vs js calculations) or the border or the padding or something.
    //That 1 is meant to make sure the new width exceeds the current width and there's enough room for the content.
    dimensions.width = clampWidth(dimensions.width + getScrollbarWidth() + 1);
  }

  return dimensions;
};
